import { Component, input, output } from '@angular/core';
import { Languages } from 'src/app/route-translate.strategy';
import { environment } from 'src/environments/environment';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss'],
  imports: [TranslatePipe],
})
export class LangSwitcherComponent {
  readonly language = input<string>(undefined);
  readonly langChanged = output<string>();
  englishAllowed = !environment.production || false; // Allow English language in non-production environments
  languages = Languages;

  changeLanguage(lang: string): void {
    this.langChanged.emit(lang);
  }
}
